import React from 'react'
import ClassicPointsExchangePage from '../components/ClassicPointsExchangePage'

const PointsPointtomoneyPage: React.FC = () => {
  return <ClassicPointsExchangePage mode="pointtomoney" />
}

export default PointsPointtomoneyPage
